import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const GroupBy = () => {
  const dispatch = useDispatch();

  const groupByOptions = useSelector((state) => state.packagesSales.groupBy);
  const selectedGroupByOptions = useSelector(
    (state) => state.packagesSales.selectedFilters.group_by
  );

  return (
    <MultiSelectDropdown
      options={groupByOptions}
      selectedFilters={selectedGroupByOptions}
      onSelectChange={(data) => dispatch(actionCreators.updateGroupBy(data))}
    />
  );
};

export default GroupBy;
